import { render, staticRenderFns } from "./firmaSucheModal.vue?vue&type=template&id=4ef15952"
import script from "./firmaSucheModal.vue?vue&type=script&lang=js"
export * from "./firmaSucheModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports